











































































import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    computed: {
        ...mapGetters([
            'meteredRate',
            'plan',
            'smsAccount',
            'selectedStripeInvoice',
            'stripeCustomer',
            'subscription',
            'tenant',
            'usedMetered',
            'yearOptions'
        ]),
        subCycleText(): string {
            if (!this.subscription) return null

            return this.plan.interval === 'month'
                ? '/mo. billed monthly'
                : '/mo. billed annually'
        },
        subNextBillAmount(): number {
            if (!this.selectedStripeInvoice) return null

            return this.selectedStripeInvoice.amount_due
        },
        subNextBillDate(): Date | string {
            if (!this.subscription) return null

            return this.subscription.current_period_end
        },
        subNickname(): string {
            if (!this.subscription) return null

            if (!this.plan.metadata) return null

            return this.plan.metadata.product_tier
        },
        subPricePerMonth(): string {
            if (!this.subscription) return null

            if (this.plan.interval === 'month') return this.plan.amount

            if (
                this.plan.interval === 'year' &&
                this.plan.metadata &&
                this.plan.metadata.price_per_month
            )
                return this.plan.metadata.price_per_month

            return null
        },
        subStatus(): string {
            //  Get the current subscription
            const sub = this.subscription

            //  If the subscription does NOT exist, OR the status does NOT exist, return nothing
            if (!sub || !sub.status) return null

            //  Else, check if the subscription is an expired trial
            const isExpiredTrial =
                sub.status === 'active' && sub.cancel_at_period_end === true

            //  If the subcription is an expired trial, return TRIAL ENDED
            if (isExpiredTrial) return 'CANCELLING AT END OF PERIOD'

            //  Else, return current subscription status (in upper-case)
            return sub.status.toUpperCase()
        },
        totalCredits(): number {
            if (!this.subscription) return 0

            if (!this.plan.metadata) return 0

            const meta = this.plan.metadata

            if (!meta.message_allowance && !meta.trial_message_allowance) return 0

            const amt =
                parseInt(meta.message_allowance) || parseInt(meta.trial_message_allowance)

            return amt || 0
        },
        remainingCredits(): number {
            if (!this.subscription) return null

            const creds = this.tenant.credits

            return creds < 0 ? 0 : creds
        }
    },
    methods: {
        popFreeMsgHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Free Messages',
                icon: 'mdi-message-text',
                color: 'primary',
                text: `Free messages are included in your MessageDesk subscription. Free messages renew every billing cycle.`,
                closeable: true
            })
        },
        popMeteredMsgHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'mdi-speedometer',
                color: 'primary',
                title: 'Metered Messages',
                text: `Metered messages are any messages you send in MessageDesk outside of your free messages. These messages get metered at a rate of $${this.meteredRate} per message, and your total usage will get added onto your invoice at the end of your billing cycle.`,
                closeable: true
            })
        },
        popNextBillHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Next Bill',
                text: 'We calculate your next bill amount based on your subscription type (monthly or annual), your subscription plan, your monthly accrued metered billing messages and any applied discounts. This bill amount reflects the exact charge that will be billed to your account on the specified date.',
                closeable: true
            })
        }
    }
})
